export default {
      id: "filters-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#filters-usage",
      toString: function () {
        return this.url;
      }
    }